import { useEffect } from 'react'
import { UseFormSetValue, FieldValues, FieldPath, SetValueConfig } from 'react-hook-form'
import { Maybe } from 'yup/lib/types'

type HookProps<T> = {
  setValue: UseFormSetValue<T>
  instance: Maybe<FieldValues>
}

/**
 * Updates form values when instance changes
 */
export function useFormUpdateEffect<T extends FieldValues>(
  { setValue, instance }: HookProps<T>,
  { shouldValidate = true, ...options }: SetValueConfig = {},
) {
  useEffect(() => {
    if (instance) {
      Object.entries(instance).forEach(([name, value]) => {
        setValue(name as FieldPath<T>, value, { shouldValidate, ...options })
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instance])
}
